import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { IxellAPIService, IAssistanceV1, IAssistanceLight } from 'src/app/tools/api.service';
import { HeaderService } from 'src/app/tools/header.service';
import { Router } from '@angular/router';
import { Utils } from 'src/app/tools/utils';
import { Language } from 'src/app/entities/Language';
import { StorageService } from '../../../tools/storage.service';
import { ErrorService } from '../../../tools/error.service';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-contact-assistance',
  templateUrl: './contact-assistance.component.html',
  styleUrls: ['./contact-assistance.component.scss']
})
export class ContactAssistanceComponent implements OnInit {
  Utils = Utils;

  private langue: Language;
  private langueSub: any;

  // Sub
  assistFormSub: any;
  assistMailSub: any;
  ctcSub: any;
  userSub: any;
  verifySub: any;

  public noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  scaleForm = new UntypedFormGroup({
    serialNumberScale: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
  });
  breakdownForm = new UntypedFormGroup({
    breakdownType: new UntypedFormControl('', [Validators.required]),
  });
  contactAssistForm = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
    firstname: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
    mail: new UntypedFormControl('', [Validators.required, Validators.email, this.noWhitespaceValidator]),
    phone: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
    comment: new UntypedFormControl('', [Validators.required, this.noWhitespaceValidator]),
    remoteMaintenanceID: new UntypedFormControl('')
  });

  userMail: string;
  mailInfo: IAssistanceV1[];
  isMaintenance: boolean = true;
  isDisplayMaintenance: boolean = true;
  invalidForm: boolean = false;
  scale: string;
  errorScale: string;
  errorScaleMsg = false;
  format: string;
  formatMsg: string;

  breakdownType = {
    "breakdown": [
      { "value": "1", "name": "assistance.materiel" },
      { "value": "2", "name": "assistance.coupure" },
      { "value": "3", "name": "assistance.tactile" },
      { "value": "4", "name": "assistance.clavier" },
      { "value": "5", "name": "assistance.pesee" },
      { "value": "6", "name": "assistance.maj" },
      { "value": "7", "name": "assistance.spectro" },
      { "value": "99", "name": "assistance.autre" }
    ]
  };

  @ViewChild('stepper') stepper: MatStepper;

  constructor(private apiService: IxellAPIService, private router: Router, private headerService: HeaderService, private storage: StorageService, private errorService: ErrorService) { }

  ngOnInit() {

    this.langueSub = this.headerService.currentLangue.subscribe(langue => {
      this.langue = langue;
    });

    // Pour afficher la flèche de retour
    this.headerService.changeCanBack(true);

    this.isMaintenance = true;

    // Récupération des données de la personne connectée    

    this.userSub = this.apiService.getUserInfos().subscribe(data => {
      if (data) {
        this.scaleForm.setValue({
          serialNumberScale: ''
        });
        this.breakdownForm.setValue({
          breakdownType: ''
        });
        this.contactAssistForm.setValue({
          firstname: data.firstname,
          name: data.name,
          mail: data.mail,
          phone: data.phone,
          comment: '',
          remoteMaintenanceID: ''
        });
        this.userMail = data.mail;
      }
    }, error => {
      console.log(error);
      if (this.userSub != null) this.userSub.unsubscribe();
    });

    // Type de balance sélectionnée
    if (this.storage.get("scale") != null) {
      this.scale = this.storage.get("scale");
    }
    else {
      this.router.navigate(['/home']);
    }

    // Contrôle selon balance sélectionnée
    if (this.scale == '1' || this.scale == '2') { // Identifiant sur 13 caractères pour les balances 1 (ColorWeb) et 2 (ColorTouch)
      switch (this.scale) {
        case '1':
          this.format = '(26)LACA[0-9]{2}(0[1-9]|1[0-2])[0-9]{3}$';
          this.formatMsg = '26LACA';
          this.errorScale = "assistance.scaleInfoColorWeb";
          break;
        case '2':
          this.format = '(28)LACA[0-9]{2}(0[1-9]|1[0-2])[0-9]{3}$';
          this.formatMsg = '28LACA';
          this.errorScale = "assistance.scaleInfoColorTouch";
          break;
      }
      this.scaleForm.controls['serialNumberScale'].setValidators([Validators.minLength(13), Validators.maxLength(13), Validators.pattern(this.format)]);
    }
    else if (this.scale == '4') { // Numéro de série sur 4 chiffres max pour la balance 3 (ColorConnect)
      this.scaleForm.controls['serialNumberScale'].setValidators([Validators.maxLength(4), Validators.pattern('^[0-9]*$')]);
      this.errorScale = "scaleform.infocode";
    }
  }

  ngOnDestroy() {
    if (this.langueSub != null) this.langueSub.unsubscribe();
    if (this.assistFormSub != null) this.assistFormSub.unsubscribe();
    if (this.assistMailSub != null) this.assistMailSub.unsubscribe();
    if (this.ctcSub != null) this.ctcSub.unsubscribe();
    if (this.userSub != null) this.userSub.unsubscribe();
  }

  ngAfterViewInit() {
    this.stepper._getIndicatorType = () => 'number';
  }

  verifyScale() {
    if (this.scaleForm.status == 'VALID') {
      if (this.scale == '4') { // ColorConnect
        this.verifySub = this.apiService.verifyBalance(this.scaleForm.value.serialNumberScale).subscribe(data => {
          if (data == true) {
            document.getElementById("scaleStepper").click();
            this.errorScaleMsg = false;
          } else {
            this.errorScaleMsg = true;
            this.scaleForm.setErrors({ 'incorrect': true });
          }
        }, error => {
          if (this.verifySub != null) this.verifySub.unsubscribe();
          this.errorService.setErrorLog("IHM", error.status.toString() + " " + error.message, "verifyBalanceSerialNumber", new Date().toString());
        })
      }
      else {
        document.getElementById("scaleStepper").click();
        this.errorScaleMsg = false;
      }
    }
  }

  sendDataAssist() {
    if (this.scaleForm.status == "VALID" && this.breakdownForm.status == "VALID" && this.contactAssistForm.status == "VALID" && this.errorScaleMsg == false) {
      let assistanceObj = new IAssistanceV1();
      assistanceObj.serialNumberScale = this.scaleForm.value.serialNumberScale.trim();
      assistanceObj.breakdownType = parseInt(this.breakdownForm.value.breakdownType);
      assistanceObj.remoteMaintenanceID = this.contactAssistForm.value.remoteMaintenanceID.trim();
      if (!this.isMaintenance) {
        assistanceObj.remoteMaintenanceID = '';
      }
      assistanceObj.name = this.contactAssistForm.value.name.trim();
      assistanceObj.firstname = this.contactAssistForm.value.firstname.trim();
      assistanceObj.mail = this.contactAssistForm.value.mail.trim();
      assistanceObj.phone = this.contactAssistForm.value.phone.trim();
      assistanceObj.comment = this.contactAssistForm.value.comment.trim();
      var radio = (<HTMLInputElement>document.querySelectorAll('input[type=radio]:checked')[0]).value; // 0 renvoit aux boutons radio pour Type de Panne 
      var id = "radio" + radio;
      let breakdownText = document.getElementById(id).innerHTML;
      let mailObj = new IAssistanceLight();
      mailObj.serialNumberScale = assistanceObj.serialNumberScale;
      mailObj.breakdownText = breakdownText;
      mailObj.remoteMaintenanceID = assistanceObj.remoteMaintenanceID;
      mailObj.name = assistanceObj.name;
      mailObj.firstname = assistanceObj.firstname;
      mailObj.mail = assistanceObj.mail;
      mailObj.phone = assistanceObj.phone;
      mailObj.comment = assistanceObj.comment;

      let language = this.storage.get("actualLanguage");
      switch (language) {
        case 'de':
          language = "German";
          break;
        case 'en':
          language = "English";
          break;
        case 'es':
          language = "Spanish";
          break;
        case 'fr':
          language = "French";
          break;
        case 'it':
          language = "Italian";
          break;
        case 'nl':
          language = "Dutch";
          break;
        case 'ro':
          language = "Romanian";
          break;
        case 'pt':
          language = "Portuguese";
          break;
        case 'pl':
          language = "Polish";
          break;
        case 'tr':
          language = "Turkish";
          break;
      };
      this.assistFormSub = this.apiService.insertAssistance(assistanceObj, language).subscribe(data => {
        if (Utils.IsNullOrWhiteSpace(this.userMail)) {
          this.userMail = this.contactAssistForm.value.mail.trim();
        }
        if (data) {
          mailObj.assistanceID = data;
          assistanceObj.assistanceID = data;
          this.assistMailSub = this.apiService.sendAssistanceMail(mailObj, this.userMail).subscribe(response => {
          }, error => {
            if (this.assistMailSub != null) this.assistMailSub.unsubscribe();
            console.log(error);
          })
          document.getElementById("finalModal").style.display = "block";
        }
      }
        , error => {
          console.log(error)
          if (this.assistFormSub != null) this.assistFormSub.unsubscribe();
        });

      this.invalidForm = false;
    } else {
      this.invalidForm = true;
      this.scaleForm.markAllAsTouched();
      this.breakdownForm.markAllAsTouched();
      this.contactAssistForm.markAllAsTouched();
      if (Utils.IsNullOrWhiteSpace(this.breakdownForm.value.breakdownType))
        document.getElementById("breakdownType").classList.add("invalid-form");
    }
  }


  removeRadioError(radioButton: string) {
    switch (radioButton) {
      case "breakdownType":
        if (document.getElementById("breakdownType").classList.contains("invalid-form"))
          document.getElementById("breakdownType").classList.remove("invalid-form");
        break;
    }
  }

  // Affichage de l'identifiant de télémaintenance
  displayMaintenance(breakdownValue: string) {
    if (breakdownValue != "1") {
      this.isDisplayMaintenance = true;
      this.isMaintenance = true;
    }
    else {
      this.isDisplayMaintenance = false;
      this.isMaintenance = false;
    }
  }

  // Choix Télémaintenance possible
  checkMaintenance(value: boolean) {
    this.isMaintenance = value;
  }


  closeModal() {
    this.router.navigate(['/home']);
    document.getElementById("finalModal").style.display = "none";
  }
}
